import { render, staticRenderFns } from "./BRELAG_MAGEvent.vue?vue&type=template&id=2dcdc04e&"
import script from "./BRELAG_MAGEvent.vue?vue&type=script&lang=js&"
export * from "./BRELAG_MAGEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports